/* Auto-built from nemiLpReward.json — every function of the contract is covered. */
import { fmt } from "../shared/format";

export const readFunctions = [
  {
    name: "NemiToken",
    title: "NEMI Token",
    description: "Read `NemiToken` from the contract",
    icon: "🪙",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "burnReward",
    title: "Burn Reward",
    description: "Read `burnReward` from the contract",
    icon: "🔥",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "getNemiPrice",
    title: "Get NEMI Price",
    description: "How much NEMI the given USDT amount is worth on the pair.",
    icon: "💲",
    category: "Economics",
    inputs: [
      { name: "usdtAmount", type: "uint256", label: "USDT Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "globalMarketPlaceReward",
    title: "Global Market Place Reward",
    description: "Read `globalMarketPlaceReward` from the contract",
    icon: "💰",
    category: "Rewards",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "globalMatrixReward",
    title: "Global Matrix Reward",
    description: "Read `globalMatrixReward` from the contract",
    icon: "💰",
    category: "Rewards",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "liquidityFundCount",
    title: "Liquidity Fund Count",
    description: "Read `liquidityFundCount` from the contract",
    icon: "📈",
    category: "Economics",
    inputs: [],
  },
  {
    name: "liquidityFundThreshold",
    title: "Liquidity Fund Threshold",
    description: "How many swaps trigger a liquidity top-up (a count).",
    icon: "💲",
    category: "Economics",
    inputs: [],
  },
  {
    name: "lpReceiver",
    title: "LP Receiver",
    description: "Read `lpReceiver` from the contract",
    icon: "🔹",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "nftMarketPlace",
    title: "NFT Market Place",
    description: "Read `nftMarketPlace` from the contract",
    icon: "🛒",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "nftMatrix",
    title: "NFT Matrix",
    description: "Read `nftMatrix` from the contract",
    icon: "🌳",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "owner",
    title: "Owner",
    description: "Read `owner` from the contract",
    icon: "👑",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "pair",
    title: "Pair",
    description: "Read `pair` from the contract",
    icon: "🔁",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "paused",
    title: "Paused",
    description: "Read `paused` from the contract",
    icon: "⏸️",
    category: "Basic Info",
    inputs: [],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "router",
    title: "Router",
    description: "Read `router` from the contract",
    icon: "🔁",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "swapCount",
    title: "Swap Count",
    description: "Read `swapCount` from the contract",
    icon: "📈",
    category: "Economics",
    inputs: [],
  },
  {
    name: "swapThreshold",
    title: "Swap Threshold",
    description: "How many reward additions trigger a swap (a count).",
    icon: "💲",
    category: "Economics",
    inputs: [],
  },
  {
    name: "usdtToken",
    title: "USDT Token",
    description: "Read `usdtToken` from the contract",
    icon: "🪙",
    category: "Basic Info",
    inputs: [],
  },
];

export const writeFunctions = [

];

export const adminFunctions = [
  {
    name: "NemiMax",
    title: "Approve NEMI Max",
    description: "Give the router an unlimited NEMI allowance.",
    icon: "🪙",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "addLiquidityFund",
    title: "Add Liquidity Fund",
    description: "Call `addLiquidityFund` on the contract",
    icon: "🔁",
    category: "Admin Operations",
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "addMarketPlaceReward",
    title: "Add Market Place Reward",
    description: "Call `addMarketPlaceReward` on the contract",
    icon: "💰",
    category: "Admin Operations",
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "addMatrixReward",
    title: "Add Matrix Reward",
    description: "Call `addMatrixReward` on the contract",
    icon: "💰",
    category: "Admin Operations",
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "initialize",
    title: "Initialize",
    description: "Call `initialize` on the contract",
    icon: "⚙️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [
      { name: "initialOwner", type: "address", label: "Initial Owner", placeholder: "0x…", required: true },
      { name: "newNemiToken", type: "address", label: "New NEMI Token", placeholder: "0x…", required: true },
      { name: "nftMarketPlaceContract", type: "address", label: "NFT Market Place Contract", placeholder: "0x…", required: true },
      { name: "newNftMatrixContract", type: "address", label: "New NFT Matrix Contract", placeholder: "0x…", required: true },
      { name: "newLpReceiver", type: "address", label: "New LP Receiver", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "newSetup",
    title: "New Setup",
    description: "Call `newSetup` on the contract",
    icon: "⚙️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "pause",
    title: "Pause",
    description: "Call `pause` on the contract",
    icon: "⏸️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "recoverErc20",
    title: "Recover ERC20",
    description: "Call `recoverErc20` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "erc20Token", type: "address", label: "ERC20 Token", placeholder: "0x…", required: true },
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverErc20All",
    title: "Recover ERC20 All",
    description: "Call `recoverErc20All` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "erc20Token", type: "address", label: "ERC20 Token", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "recoverEth",
    title: "Recover ETH",
    description: "Call `recoverEth` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverUsdt",
    title: "Recover USDT",
    description: "Call `recoverUsdt` on the contract",
    icon: "🪙",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverUsdtAll",
    title: "Recover USDT All",
    description: "Call `recoverUsdtAll` on the contract",
    icon: "🪙",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "renounceOwnership",
    title: "Renounce Ownership",
    description: "Call `renounceOwnership` on the contract",
    icon: "👑",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "setLiquidityFundThreshold",
    title: "Set Liquidity Fund Threshold",
    description: "Call `setLiquidityFundThreshold` on the contract",
    icon: "💲",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newLiquidityFundThreshold", type: "uint256", label: "New Liquidity Fund Threshold", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setLpReceiver",
    title: "Set LP Receiver",
    description: "Call `setLpReceiver` on the contract",
    icon: "⚙️",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newLpReceiver", type: "address", label: "New LP Receiver", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setNemiToken",
    title: "Set NEMI Token",
    description: "Call `setNemiToken` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNemiToken", type: "address", label: "New NEMI Token", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setNewNftMarketPlace",
    title: "Set New NFT Market Place",
    description: "Call `setNewNftMarketPlace` on the contract",
    icon: "🛒",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNftMarketPlace", type: "address", label: "New NFT Market Place", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setNftMatrixContract",
    title: "Set NFT Matrix Contract",
    description: "Call `setNftMatrixContract` on the contract",
    icon: "🌳",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNftMatrix", type: "address", label: "New NFT Matrix", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setRouterAndPair",
    title: "Set Router And Pair",
    description: "Call `setRouterAndPair` on the contract",
    icon: "🔁",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newRouter", type: "address", label: "New Router", placeholder: "0x…", required: true },
      { name: "newPair", type: "address", label: "New Pair", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setTokenApproveMax",
    title: "Set Token Approve Max",
    description: "Call `setTokenApproveMax` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "setUsdtToken",
    title: "Set USDT Token",
    description: "Call `setUsdtToken` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newToken", type: "address", label: "New Token", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setswapThreshold",
    title: "Setswap Threshold",
    description: "Call `setswapThreshold` on the contract",
    icon: "💲",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newswapThreshold", type: "uint256", label: "Newswap Threshold", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "swap",
    title: "Swap",
    description: "Swap the collected USDT into NEMI (runs when the threshold is reached).",
    icon: "🔁",
    category: "Admin Operations",
    inputs: [],
  },
  {
    name: "transferOwnership",
    title: "Transfer Ownership",
    description: "Call `transferOwnership` on the contract",
    icon: "👑",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [
      { name: "newOwner", type: "address", label: "New Owner", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "unpause",
    title: "Unpause",
    description: "Call `unpause` on the contract",
    icon: "▶️",
    category: "Admin Control",
    ownerOnly: true,
    allowWhilePaused: true,
    inputs: [],
  },
  {
    name: "usdtMax",
    title: "Approve USDT Max",
    description: "Give the router an unlimited USDT allowance.",
    icon: "🪙",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [],
  },
];

const lpRewardFunctions = { readFunctions, writeFunctions, adminFunctions };
export default lpRewardFunctions;
